export default {
  message: {
    hello: '主页',
    fee: '允许其他用户添加收费内容:',
    wasCreated: '成功创建',
    displayDelete: '您确定要删除这个显示器吗?',
    campaignDelete: '您确定要删除此活动吗?',
    newsDelete: '确定要删除这条新闻吗？',
    mediaDelete: '确定要删除这个媒体吗?',
    teamDelete: '您确定要删除这个团队吗?',
    teamDeleteConfirm: '此操作会删除此团队（视频，活动，显示内容），请确认删除',
    userDelete: '您确定要删除这个用户吗?',
    leaveTeam: '您确定要离开',
    noDeal: '服务器上似乎没有新的优惠码可以在这里添加.',
    closeDeal: '您可以关闭优惠码的重获.',
    addTag: '键入添加标签',
    inUse: '正在使用',
    inUseDelete: '在使用时无法删除',
    notUsed: '此媒体项目未在任何活动中使用',
    choose: '选择一个文件',
    drag: '或拖动它在这里',
    errorAudio: '您的浏览器不支持音频元素',
    noTeam: '您不属于任何团队',
    noDisplay: '这个团队没有任何显示',
    noCampaigns: '这个团队没有任何活动',
    noInvoice: '没有发票给您',
    noLogs: '没有日志给您',
    stripeAccept: '要能够接受活动商的付款，您必须将您的团队连接到Stripe',
    resetPassword: '要重置密码，请在下面输入您的电子邮件.',
    forgotSent: '如果提供的电子邮件地址正确，您将收到一封电子邮件，其中包含进一步的指示',
    error:'错误',
    success:'成功',
    alert:'警告',

  },
  article: {
    on: '打开',
    displayOffline: '离线显示',
    lastConnected: '最后连接'
  },
  actions: {
    actions: '操作',
    search: '搜索',
    delete: '删除',
    deleteNews: '删除新闻',
    view: '查看',
    edit: '编辑',
    coupons: '优惠券',
    pricing: '定价',
    dashboard: '控制面板',
    group: '分组',
    leave: '离开'
  },
  show: {
    show: '显示',
    hide: '隐藏'
  },
  measurement: {
    centimetres: '厘米',
    seconds: '秒'
  },
  countries: {
    aus: '澳大利亚',
    cn: '中国'
  },
  truth: {
    false: '模拟',
    true: '真实'
  },
  approval: {
    pending: '待定',
    approved: '批准',
    denied: '否认'
  },
  brightnessControl: {
    maximum: '最大',
    sensor: '传感器',
    scheduled: '预定'
  },
  privacy: {
    private: '私人',
    public: '公共'
  },
  screenType: {
    LCD: 'LCD',
    LEDIndoors: 'LED室内',
    LEDOutdoors: 'LED户外'
  },
  currency: {
    currency: '货币',
    AUD: 'aud',
    CNY: 'cny',
    fullAud: '澳大利亚货币',
    fullCny: '人民币',
    symbol: '¥'
  },
  answers: {
    yes: '是的',
    no: '不是'
  },
  fonts: {
    futura: 'futura',
    helvetica: 'helvetica',
    arial: 'arial'
  },
  fontStyle: {
    normal: '正常',
    italic: '斜体',
    oblique: '倾斜'
  },
  fontWeights: {
    normal: '标准',
    bold: '宽体',
    bolder: '更宽',
    lighter: '更亮'
  },
  common: {
    tags: '标签',
    admin: '管理员',
    name: '名字',
    description: '描述',
    dimensions: '尺寸',
    information: '信息',
    approval: '批准',
    edit: '编辑',
    team: '团队',
    id: '身份',
    teamId: '团队身份',
    preview: '预览',
    schedule: '时间表',
    scheduled: '已预定',
    loading: '加载中',
    type: '类型',
    key: '密钥',
    total: '总计'
    },
  buttons: {
    close: '关闭',
    next: '下一个',
    previous: '上一个',
    addCampaign: '添加活动',
    bookCampaign: '预约活动',
    create: '创建',
    edit: '编辑',
    delete: '删除',
    remove: '移除',
    createCoupon: '创建优惠券',
    save: '保存',
    back: '返回',
    schedule: '时间表',
    add: '添加',
    upload:'上传',
    addText: '添加文本',
    update: '更新',
    addKey: '添加密钥',
    verify: '用户检验',
    verified: '以检验',
    date:'日期',
    name:'名字',
    size:'大小',
    dimensions:'规模',
    all:'所有',
    image:'图像',
    video:'视频',
    saveCampaign: '保存活动',
    search:'搜索',
    setting:'设置',
    pricingCal:'价格计算器',
    cancel: '取消',
  },
  // Destructive-action prompts (src/lib/confirm.js)
  confirm: {
    removeMember: {
      title: '移除团队成员',
      message: '要将 {name} 移出此团队吗？对方将无法再访问此团队。'
    },
    deleteKey: {
      title: '删除密钥',
      message: '要从此团队删除 {name} 密钥吗？'
    },
    deleteImage: {
      title: '删除图片',
      message: '要从此显示器的图库中删除 {name} 吗？'
    },
    denyBooking: {
      title: '拒绝预订',
      message: '要拒绝 {campaign} 在 {display} 上的预订吗？该预订将不会播放。'
    },
    clearAll: {
      title: '清除所有预订',
      message: '要从符合当前筛选条件的 {displays} 块显示器上移除全部 {bookings} 项活动预订吗？其他页上的显示器也包括在内。E2V 来源预订将保留。'
    },
    deleteDisplay: {
      title: '删除 {name}',
      message: '您确定要删除这个显示器吗?'
    }
  },
  restrict: {
    toMine: '对我的限制',
    incPublic: '包括公众',
    campaigns: '限制活动'
  },
  dateTime: {
    sDate: '开始日期',
    eDate: '结束日期',
    sTime: '开始时间',
    eTime: '结束时间',
    duration: '持续时间',
    eDay: '每一天',
    dailyTimes: '每天运行时间',
    runDates: '运行日期',
    date: '日期',
    time: '时间',
    seconds: '秒',
    secondsLeft: '剩余秒数',
    min5: '5分钟',
    min10: '10分钟',
    min15: '15分钟',
    min30: '30分钟'
  },
  map: {
    searchOptions: '搜索选项',
    bookingOptions: '预订选项',
    searchResults: '搜索结果',
    preparingDisplays: '搜索中', 
    displayType: '屏幕类型',
    displayDetails: '屏幕详情',
    bookingDetails: '预订详情',
    costOfBooking: '预订费用',
    addToCart: '加入购物车',
    findDisplays: '搜索可用屏幕',
    date: '日期'
  },
  index: {
    dashboard: '控制面板',
    scheduling: '时间安排',
    displays: '显示',
    campaigns: '活动',
    media: '媒体',
    teams: '团队',
    users: '用户',
    admin: '系统管理员',
    publicteams: '公共队列',
    teammgt: '团队管理',
    usermgt: '用户管理'
  },
  sources: {
    sources: '资源',
    source: '资源',
    newSource: '新资源',
    sourceName: '资源名字',
    uri: 'URI',
    uriDesc:'URI创建后无法被更改',
    apiKey: 'API密钥',
    apiDesc:'用于访问的API密钥(如果需要)',
    name:'名字',
    nameDesc:'E2V资源名字',
    team:'团队',
    teamDesc:'团队创建后无法被更改',
    badUrl:'提供的URL未返回正确的数据.',
    goodUrl:'正确的URL.',
    editDetail:'编辑',
    sourceNamePH:'您的资源名字',
    status:'状态',
    latency:'延迟（ping）',
    APIVer:'API版本',
    campaign:'可用播放列表',
    author:'作者',
    campany:'公司',
    email:'联系邮件',
    phone:'联系电话',
    update:'每5秒更新',
    current:'目前状态',



  },
  schedule: {
    lastUpdate:'最近更新',
    map: '公共',
    ipam: '私人',
    selectCampaign: '选择活动',
    displayRunning: '显示运行时间',
    campaignDuration: '活动持续时间',
    selectSource:'选择资源',
    oldest:'最早',
    newest:'最新',
    searchCampaigns:'搜索活动',
    searchDisplay:'搜索显示器',
    allTeam:'所有团队',
    selectTeam:'选择团队',
    prePage:'上一页',
    nexPage:'下一页',
    active:'激活',
    loading:'加载中',
    ipamTitle:'私人预订',
    lastUpdateText:'最近更新',
    noCampaignFound:'没找到播放列表或者E2V资源.',
    noDisplayFound:'没找到屏幕.',
    updateUnit:'秒 前',
    adminSchedule:'管理员帐号无法使用公共预订功能',




  },
  dashboard: {
    headers: {
      dashboard: '控制面板', 
      welcome: '欢迎回来 ',
      twowelcome: ', 您上一次登录于',
      campaigns: '活动',
      displays: '显示器',
      approval: '批准的队列',
      activeTeam:'已存在团队',

    },
    campaigns: {
      header: '目前正在运行的活动',
      name: '活动',
      display: '显示',
      campaigns: '活动',
      teaminfo: '团队信息',
      belongsto: '此播放列表所属团队： ',
      lastPlayed: '最后播放列表',
      pause:'暂停/继续',
      clientUptime:'用户在线时间',
      updateTime:'每30秒更新',



    },
    displays: {
      header: '我的显示器上的活动',
      name: '活动名称',
      display: '显示名称'
    },
    approval: {
      header: '等待批准的预定活动',
      name: '活动名称',
      display: '显示名称',
      start: '开始',
      end: '结束',
      status: '状态',
      approve: '批准',
      deny: '拒绝',
      advertiser: '活动客户'
    },
    common: {
      restrict: '限制',
      refresh: '刷新',
      approvalQueue: '待核准',
      network: '显示屏状态',
      news: '新闻',
      allDisplays: '所有显示器在线',
      online: '在线',
      passive: '暂时离线',
      offline: '离线',
      lastUpdated: '自动更新于10秒前',
      disconnected: '当前无法连接，请稍后重试',
      loading: '加载中',
      support: '支持',
      noTeamDisplay:'此团队暂无屏幕.',

    },
    campaignStats: {
      campaigns: '活动',
      playingCampaigns: '播放',
      schedCampaigns: '待播放',
      waitApproval: '待审核'
    },
    mediaStats: {
      image: '图片',
      video: '视频',
      audio: '音频',
      used: '以用空间'
    },
    links: {
      quickLinks: '快速连接',
      liveView: '实时画面',
      upload: '上传',
      newCampaign: '新建活动',
      newDisplay: '新建播放器'
    },
    metrics: {
      displayMetrics:'实时监控',
    }
  },

  ipam: {
    displayFilter: '显示过滤器:',
    campaignFilter: '活动过滤器:',
    date: '日期:',
    show: '展示:',
    add: '添加',
    playing: '播放中',
    scheduled: '预定',
    noDisplay: '我们找不到任何活动或显示器!',
    newest: '最新'
  },
  news: {
    postedBy: '发布人',
    on: '发布于',
    theDate: '2019-04-09',
    newsContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  },

  admin:{
    admin: '管理员',
    news: '新闻',
    newsHere: '在此输入新闻',
    title: '标题:',
    createNews: '新建新闻',
    body: '内容'
  },
  displays: {
    newDisplay: '新显示器',
    displays: '显示器',
    display: '显示器',
    dName: '显示器名字',
    dDescription: '显示器描述',
    dDimenstions: '显示器尺寸',
    maxTime: '最多可购买时间',
    location: '位置',
    timezoneCurrency: '时区和货币',
    locationTime: '位置和时间',
    brightness: '亮度设置',
    type: '类型',
    privacy: '隐私',
    loop: '循环时间 (单位：秒，最长不超过1小时)',
    physicalHeight: '实际高度',
    physicalWidth: '实际宽度',
    pixelHeight: '像素高度',
    pixelWidth: '像素宽度',
    rotation: '旋转屏幕',
    screenMobility: '屏幕移动性',
    mobility: '移动性',
    mobile: '可移动',
    stationary: '固定式',
    longitude: '经度',
    latitude: '纬度',
    aLongitude: '平均经度',
    aLatitude: '平均纬度',
    timezone: '时区',
    currency: '货币',
    brightnessControl: '亮度控制',
    brightnessCurve: '亮度曲线',
    acid: 'ACID',
    hwid: '硬件ID',
    demoMode: '演示模式',
    addTags: '键入以添加标签',
    hardwareId: '硬件ID',
    publicUrl: '公共网址',
    count: '观看次数',
    hwidErro:'无效的硬件ID',
    public: '公共',
    private: '私人',
    address:'地址',
    byLatLn:'按经纬度',
    byAdd:'按地址',
    addImage:'添加新图片',
    noImage:"无图片",
    isRequired: '不能为空',
    defaultPrice:'默认价格按每秒(分)',
    fullURL:'完整URL: https: ',

    updateInterval:'更新间隔（秒）:',
    diskUsage:'磁盘使用',
    memoryUsage:'内存使用',
    CPULoad:'CPU占用',
    wirelessSignal:'无线信号',


  },
  displayCoupon: {
    new: '新优惠券',
    code: '代码',
    expiry: '到期时间',
    price: '价格',
    percentage: '百分比',
    quantity: '数量',
    couponCode: '优惠券代码',
    value: '价值',
    unlimited: '无限制'
  },
  displayPricing: {
    default: '默认定价',
    new: '新定价计划',
    pps: '每秒价格',
    pricingSchedule: '定价计划',
    priority: '优先权',
    select: '选择一个选项'
  },
  campaigns: {
    campaigns: '播放列表',
    campaign: '播放列表',
    campaignCap: '播放列表',
    newCampaign: '新的播放列表',
    campaignName: '播放列表名字',
    position: '位置',
    width: '宽度',
    height: '高度',
    created: '创建',
    size: '尺寸',
    frameDuration: '播放时长',
    emptyName:'请输入一个活动名字',
    emptyTeam:'请输入一个团队名字',
    campaignTagDesc:'在这里更改活动标签',
    teamTagDesc: '在这里更改团队标签',
    create: '创建',
    updateTeam: '更新团队',
    noTeam:'没有被选中的团队',
    noCampaigns:'无播放列表',
  },
  media: {
    media: '媒体',
    create: '创建或上传媒体',
    fontFamily: '字体',
    fontSize: '字体大小',
    fontStyle: '字体格式',
    fontWeight: '字体宽度',
    mimeType: '多用途互联网邮件扩展',
    text: '文字',
    allTeam:'所有团队'

  },
  user: {
    user: '用户',
    users: '用户',
    accountActivated: '您的账户已成功激活',
    activationProblem: '激活账户失败，请联系我们',
    accountDetails: '帐户详细信息',
    update: '更新帐户',
    username: '用户名',
    email: '电子邮件',
    emailVerified: '电子邮件验证',
    created: '创建',
    lastLogin: '上次登录',
    lastModified: '上次修改',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    usernameEmail: '用户名/电子邮件',
    enterPassword: '输入密码',
    enterEmail: '输入电子邮件'
  },
  register:{
    lgName:'注册的用户名.',
    lgPass:'账户的密码.',
    registerActi:'您的帐号已注册但需要激活',
    registerEmail:'邮件已经发送至您的邮箱确认注册',
    registerSuc:'创建成功',
    registerName:'用户名',
    email:'电子邮件',
    password:'密码',
    // 两步注册（Register.vue）。
    stepOf: '第 {step} 步，共 {total} 步',
    accountTitle: '创建您的账户',
    accountLead: '在任何设备上管理您的屏幕，并在公开屏幕上预订付费广告。',
    usernameHint: '用于登录。可使用字母、数字、点、下划线或连字符。',
    emailHint: '用于账户通知和激活。',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    continue: '继续',
    checking: '正在检查…',
    haveAccount: '已有账户？',
    activateTitle: '激活您的账户',
    activateLead: '验证一张银行卡即可立即激活账户。该卡仅在您预订其他团队的屏幕时使用。',
    verifyAndCreate: '验证银行卡并创建账户',
    creating: '正在创建账户…',
    skipHint: '没有银行卡？我们的团队将人工审核并激活您的账户，以防止欺诈。',
    skip: '跳过，人工激活',
    rule: {
      length: '12 至 32 个字符',
      lengthBytes: '过长：部分字符按两个或更多字符计算',
      chars: '不含 < " 或 \' 字符',
      personal: '不包含您的用户名或邮箱',
      leakIdle: '未出现在已知数据泄露中（继续时检查）',
      leakChecking: '正在检查已知数据泄露…',
      leakOk: '未在已知数据泄露中发现',
      leakFound: '曾出现在数据泄露中：请换一个密码',
      leakUnknown: '暂时无法检查数据泄露',
    },
    err: {
      usernameRequired: '请输入用户名。',
      usernameChars: '只能使用字母、数字、点、下划线或连字符（不能有空格或 @）。',
      usernameTooLong: '过长：最多 32 字节（每个中文字符按 3 字节计算）。',
      emailRequired: '请输入邮箱地址。',
      emailInvalid: '请输入有效的邮箱地址，例如 name@example.com。',
      emailTooLong: '邮箱地址过长。',
      password: '请设置符合以下所有规则的密码。',
      leaked: '此密码曾在数据泄露中出现，请换一个。',
      bot: '创建账户时出错，请重试。',
    },

  },
  teams: {
    teams: '团队',
    newTeam: '新的团队',
    slug: '团队别名',
    addUser: '添加用户',
    addUsers: '添加用户',
    description: '描述',
    public: '公共团队',
    email: '团队联系邮箱'
  },
  permissions: {
    permissions: '允许',
    owner: '所拥有者',
    display: '显示器',
    pricing: '定价',
    campaign: '活动',
    media: '媒体',
    invoice: '收据',
    thirdParty: '第三方钥匙',
    team: '团队'
  },
  stripe: {
    toConnect: '链接Stripe',
    connected: '与Stripe相连接'
  },
  invoices: {
    invoices: '发票'
  },
  event: {
    log: '事件日志',
    ip: 'IP地址',
    agent: '用户代理'
  },
  account: {
    my: '我的账户',
    logout: '注销',
    login: '登录',
    register: '注册',
    forgotPassword: '忘记密码',
    passwordReset: '重设密码',
    resetPassword: '重置密码',
    backToLogin: '返回登录',
    loginTitle:'登录',
    stripeCon:'连接您的团队到Stripe',
  },
  language: {
    language: '语言',
    languages: '语言',
    chinese: '中文',
    english: '英文',
  },
  popover: {
  },

  checkout: {
    checkout: '支付',
    dailyPlay:'每天播放时间：全天',
    daily:'每天播放时间：',

  },
  notifications: {
    noMedia: '无视频，在修改活动之前请添加视频',
    sourceCreate: '资源已生成',
    sourceError: '错误:修改资源时出现',
    sourceDelete: '资源已被删除',
    sourceDeleteError: '错误:删除资源时出现',
    sourceUpdate: '资源已更新',
    campaignCreateError: '在您尝试创建活动时似乎出现了错误',
    campaignError: '在您尝试创建活动时似乎出现了错误',
    campaignSave: '活动已保存',
    campaignSaveError: '错误：保存活动时产生',
    campaignDelete: '您已经删除该活动',
    campaignDeleteError: '错误：尝试删除您的活动时产生',
    campaignApprove: '活动已经被确认',
    campaignApproveError: '错误：尝试确认该活动时产生',
    campaignDenied: '活动已经被拒绝',
    campaignDeniedError: '错误：尝试拒绝该活动时产生',
    campaignBook: '您已经预订了一个活动',
    campaignBookError: '错误： 尝试预订一个活动时产生',
    campaignRemove: '该活动已被移除',
    campaignTeamUpdate: '活动团队已经更新',
    campaignRemoveError: '错误：尝试移除活动时产生',
    mediaRemove: '您已经成功从活动中移除该视频',
    mediaRemoveError: '错误：尝试删除该项时产生',
    mediaFetchError: '错误： 获取您的视频时产生',
    mediaNone: '无视频，请在创建/编辑活动前添加视频',
    mediaDelete: '已删除视频',
    mediaDeleteError: '错误：无法删除视频',
    frameRemove: '错误：尝试删除该框架时产生',
    costFetchError: '错误：尝试获取费用时产生',
    teamNone: '在操作之前您必须创建或者被邀请至一个团队',
    userRemove: '您已经移除该用户',
    userRemoveError: '错误：移除该用户时产生',
    userKick: 'You have kicked',
    userAddError: '错误：添加用户至该团队时产生',
    userFetchError: '错误：获取用户信息失败',
    userPermissionUpdate: '您已经保存该用户的团队权限',
    userPermissionUpdateError: '错误：更新该用户权限时产生',
    teamUpdate: '您已经更新该团队信息',
    teamLeave: '您已经离开该团队',
    keyUpdateError: '错误：创建密钥时产生',
    keyRemove: '该密钥已经成功删除',
    keyFetchError: '错误：获取该团队密钥时产生',
    stripeConnect: '您的团队已经成功连接到stripe',
    stripeConnectError: '错误：尝试连接您的团队至stripe时产生',
    stripeUserError: '错误：授权您的团队时产生',
    tagRemove: '从活动移除',
    tagAdded: '添加至活动',
    tagLengthError: '错误：请使用长度超过255个字数的标签',
    displayFetchError: '错误：获取显示器信息错误',
    displayDelete: '您已删除该显示器',
    newsDelete: '您已经删除该新闻',
    displayDeleteError: '错误：删除显示器错误',
    newsDeleteError: '错误：删除新闻错误',
    displayTagRemove: '标签已经从显示器移除',
    displayTagRemoveError: '错误：移除标签错误',
    displayTagAdd: '标签已添加',
    displayTagAddError: '错误：添加标签错误',
    displayUpdate: '显示器已成功更新',
    displayUpdateError: '错误：更新显示器错误',
    displayTeamMissing: '您需要加入一个团队来创建显示器',
    displayPricingDefaultError: '错误：在他人使用前您需要创建一个显示器',
    couponExists: '此优惠券已存在，请使用其他优惠券',
    couponDelete: '您已经删除此优惠券',
    couponDeleteError: '错误：删除优惠券错误',
    pricingDefaultUpdate: '默认定价表已经成功更新',
    pricingScheduleCreate: '新的定价表已经成功生成',
    pricingScheduleCreateError: '错误：生成定价表错误',
    pricingScheduleUpdate: '定价表已经更新成功',
    pricingScheduleUpdateError: '错误：更新定价表错误',
    messageSaveError: '错误：存储信息错误',
    accountActivateError: '错误：激活帐号错误',
    accountUpdate: '您的帐号已经成功更新',
    invalidFileFormat: '是一个无效的文件格式',
    cartAdd: '加入购物车',
    cartAddError: '错误：不能多次添加同一个预订',
    teamRemove: '您已经将该团队从数据库移除',
    teamremoveError: '错误：当您尝试从数据库中删除该团队',
    teamDisplayNone: '该团队不存在任何显示器',
    teamNotExist: '该团队不存在',
    accountActivated: '该用户已被激活',
    passwordSuccess: '您的密码已更新',
    passwordFailure: '密码更新失败',
  },
  tutorial:{ // flavour text 
    teamExample: '该功能用以解决团队事务',
    dashboardExample: '您必须拥有设备才能查看网络窗口',  // tutorial to go through the entire process on youtube, try to make vue display this only if it is not visible.
    schedulingExample: 'IPAM 是用来预约显示活动的地方. 公共屏幕按默认内容播放，您需要付费来预订播放内容。活动内容一旦预约后就无法更改，回访状态会网络环境影响',
    displaysExample: '您的团队所拥有的设备可以在这里查看，您可以更改设备设置，安排定价和优惠券。如果设备处于上线状态您做的任何更改都会立即响应.',
    newDisplayExample: '当您第一次打开Adverclient后该功能就能显示，如果无法显示请联系我们协助', //(screenshot of hardware id screen to be added) 
    newDisplayWarning: '※ 在您开始使用前设备必须被许可，如果持续超过24小时请联系我们',
    campaignsExample: '该功能用以查看和编辑您的活动，被预订的活动不能被更改',
    mediaExample: '在这里上传的视频会被自动最佳化，请确保上传的视频分辨率不超过屏幕的两倍不然图片质量会有影响',
    acceptedFileFormats: '支持所有常规格式的图片和视频',
    publicteamsExample: '公共团队管理样例', //visible but not sure if necessary??
    teammanagementExample: '团队管理样例', //""
    usermanagementExample: '用户管理样例', //""
    sources:'资源',
  },
  home:{
    heroHeader: '广告牌广告不再遥不可及',
    heroText: '合理的预算在任何地方的' + process.env.VUE_APP_NAME + '电子广告牌上做广告，令您的生意蓬勃发展。',
    mapHeader: process.env.VUE_APP_NAME + '广告牌地点',
    mapText: '在你所在的城市，在你的预算范围内，通过' + process.env.VUE_APP_NAME + '广告牌上的户外数字媒体来让你的营销活动充满活力。',
    mapRed: '缩小',
    mapCaption: '以查看您所在城市外的广告牌',
    stepHeader: process.env.VUE_APP_NAME + '如何工作',
    step1Header: '选择您的广告牌地点',
    step1Text: '在交互式的' + process.env.VUE_APP_NAME + '上地图选择您城市或者其他城市的屏幕打广告。',
    step2Header: '设置您的预算和播放时间',
    step2Text: '给您的广告列表设置预算和播放时间',
    step3Header: '上传您的文件',
    step3Text: '上传您的文件，生成符合您屏幕尺寸的播放列表。您的文件可被存储在' + process.env.VUE_APP_NAME + '云平台上以便日后重复使用。',
    step4Header: '等待确认',
    step4Text: '您的播放列表会被发送给屏幕的所有者确认。' + process.env.VUE_APP_NAME + '会以一份可下载的报告形式让您追踪广告的播放情况以便于您管理您的市场营销活动。',
    barHeader: '现在开始免费注册您的账号吧',
    barText: '准备好开启您的广告营销了吗？现在开始免费注册您的' + process.env.VUE_APP_NAME + '账号吧。',
    ownerHeader: '已经拥有一块电子显示屏？',
    ownerText: process.env.VUE_APP_NAME + '是一个完整的云解决方案。无论您的电子广告牌是LED、LCD还是定制设计;我们总有一个适合你的Adverclient方案。',
    signUp: '注册',
    footer: {
      contact: '联系我们',
      support: '支持',
      owners: '屏幕所有者',
      tos: '服务条款 (英语)',
      privacy: '隐私政策 (英语)',
      ip: '知识产权 (英语)'
    }
  },
}
